import { createFileRoute } from "@tanstack/react-router";

import { AdminGuard } from "@/components/admin/AdminGuard";
import { AdminAgentsPage } from "@/components/admin/agents/AdminAgentsPage";

export const Route = createFileRoute("/admin/agents")({
  component: AdminAgentsRoute,
});

function AdminAgentsRoute() {
  return (
    <AdminGuard>
      <AdminAgentsPage />
    </AdminGuard>
  );
}
